"use client";

import { c as _c } from "react/compiler-runtime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, useTheme } from "@mui/material";
import styles from "./Stepper.module.css";
interface StepIndicatorProps {
  stepNumber: number;
  isActive: boolean;
  isCompleted: boolean;
  isFuture: boolean;
}
export function StepIndicator(t0) {
  const $ = _c(8);
  const {
    stepNumber,
    isActive,
    isCompleted,
    isFuture
  } = t0;
  const theme = useTheme();
  if (isCompleted) {
    let t1;
    if ($[0] !== theme.palette.text.secondary) {
      t1 = <CheckCircleIcon sx={{
        color: theme.palette.text.secondary,
        height: "30px",
        width: "30px"
      }} />;
      $[0] = theme.palette.text.secondary;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let color;
  if (isActive) {
    color = theme.palette.text.secondary;
  } else {
    if (isFuture) {
      color = theme.palette.text.disabled;
    } else {
      color = theme.palette.text.light;
    }
  }
  const t1 = isActive ? `1px solid ${theme.palette.text.secondary}` : "none";
  let t2;
  if ($[2] !== color || $[3] !== t1) {
    t2 = {
      border: t1,
      color,
      background: _temp
    };
    $[2] = color;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== stepNumber || $[6] !== t2) {
    t3 = <Box aria-hidden="true" sx={t2} className={styles.leftPanelIcon}>{stepNumber}</Box>;
    $[5] = stepNumber;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(theme_0) {
  return theme_0.palette.neutral2.light;
}